import faceChangeJSON from "./SpecialEffectIcon/lotties/faceChange.json";
import tornadoJSON from "./SpecialEffectIcon/lotties/Tornado.json";
import welcomeJSON from "./SpecialEffectIcon/lotties/Welcome.json";
import cryJSON from "./SpecialEffectIcon/lotties/cry.json";
import heartJSON from "./SpecialEffectIcon/lotties/heart.json";
import bombJSON from "./SpecialEffectIcon/lotties/Bomb.json";
import skateJSON from "./SpecialEffectIcon/lotties/Skate.json";
import celebrateJSON from "./SpecialEffectIcon/lotties/Celebrate.json";

import soundBoomMP3 from "./SpecialEffectIcon/soundEffects/boom.mp3";
import soundCelebrateMP3 from "./SpecialEffectIcon/soundEffects/celebrate.mp3";
import soundCryMP3 from "./SpecialEffectIcon/soundEffects/cry.mp3";
import soundFaceChangeMP3 from "./SpecialEffectIcon/soundEffects/faceChange.mp3";
import soundHeartMP3 from "./SpecialEffectIcon/soundEffects/heart.mp3";
import soundSkateMP3 from "./SpecialEffectIcon/soundEffects/skate.mp3";
import soundTornadoMP3 from "./SpecialEffectIcon/soundEffects/tornado.mp3";
import soundWelcomeMP3 from "./SpecialEffectIcon/soundEffects/welcome.mp3";

export const FaceChangeJSON = faceChangeJSON;
export const TornadoJSON = tornadoJSON;
export const WelcomeJSON = welcomeJSON;
export const CryJSON = cryJSON;
export const HeartJSON = heartJSON;
export const BombJSON = bombJSON;
export const SkateJSON = skateJSON;
export const CelebrateJSON = celebrateJSON;

export const SoundBoomMP3 = soundBoomMP3;
export const SoundCelebrateMP3 = soundCelebrateMP3;
export const SoundCryMP3 = soundCryMP3;
export const SoundFaceChangeMP3 = soundFaceChangeMP3;
export const SoundHeartMP3 = soundHeartMP3;
export const SoundSkateMP3 = soundSkateMP3;
export const SoundTornadoMP3 = soundTornadoMP3;
export const SoundWelcomeMP3 = soundWelcomeMP3;

export * from "./ChannelMenuIcon";
export * from "./ChatBottomToolIcon";
export * from "./FriendsChatIcon";
export * from "./SideMenuIcon";
export * from "./SpecialEffectIcon";
export * from "./TopMenuIcon";
